"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlockInProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var classnames_1 = __importDefault(require("classnames"));
var DealType_1 = __importDefault(require("./DealType"));
var Rating_1 = __importDefault(require("./Rating"));
var stylesUnlock_1 = require("./stylesUnlock");
var UnlockApply_1 = require("./UnlockApply");
var UnlockSelf_1 = require("./UnlockSelf");
var utils_1 = require("./utils");
var UnlockInProgress = function (_a) {
    var _b;
    var deal = _a.deal;
    return ((0, jsx_runtime_1.jsx)(stylesUnlock_1.Root, __assign({ className: stylesUnlock_1.classes.unlockDeal }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 2 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexGrow: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: (0, classnames_1.default)(stylesUnlock_1.classes.amount, 'success') }, { children: "Deal unlocked!" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(Rating_1.default, { rating: (0, utils_1.getServiceRating)((_b = deal.service) === null || _b === void 0 ? void 0 : _b.rating) }) })] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ className: stylesUnlock_1.classes.grayedOut }, { children: (0, jsx_runtime_1.jsx)(DealType_1.default, { deal: deal, hideValue: true }) })), deal.dealActivationType === 'Self-served' && (0, jsx_runtime_1.jsx)(UnlockSelf_1.UnlockSelf, { deal: deal }), deal.dealActivationType === 'Application required' && (0, jsx_runtime_1.jsx)(UnlockApply_1.UnlockApply, { deal: deal })] })) })));
};
exports.UnlockInProgress = UnlockInProgress;
